import React from 'react';
import {Button, Card, Form, Input, message, Spin,Tooltip,Icon} from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {inEditMode} from "../../redux/actions/global";
import {patchEventHeader} from "../../services/evt";
import CkUpload from "../../components/CkUpload";
import DefaultPromoteLogo from '../../style/imgs/invitation-page/qrcod.png'


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewWxContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }
    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                const that = this;
                patchEventHeader(Object.assign({id: this.props.evt.header.id}, values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    render() {
        const evt = this.props.evt;

        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={this.intoEdit}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>


        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{padding: "16px"}}>
                        {editableTools}
                        {
                            <CkInfoItem label={<div>
                                微信二维码&nbsp;（配置后，联系主办方的方式将由电话改成此二维码）
                                {/*<span title="" style={{marginLeft: "3px", cursor:"pointer"}} onClick={() => window.open('https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#UVUJ9')}><Icon type="question-circle-o"/></span>*/}
                            </div>} contentIndent={false}>
                                <div style={{width: "100%", height: "100px"}}>
                                    {
                                        this.props.editable ?
                                            getFieldDecorator('contactQrcodeImg', {
                                                initialValue: evt.header.contactQrcodeImg,
                                                getValueFromEvent: (fileUrlObj) => {
                                                    return fileUrlObj.url;
                                                }
                                            })(
                                                <CkUpload
                                                    width={100}
                                                    height={100}
                                                />
                                            )
                                            :
                                            (evt.header.contactQrcodeImg ? <img style={{width: 100, height: 100}} src={evt.header.contactQrcodeImg}/> : '')

                                    }
                                </div>
                            </CkInfoItem>
                        }
                        {
                            <CkInfoItem label={"文字描述"}>
                                {
                                    this.props.editable ?
                                        getFieldDecorator('contactQrcodeText', {
                                            initialValue: evt.header.contactQrcodeText,
                                            rules: [
                                                {type: "string", min: 2, max: 50, message: '长度限制为2至50个之间!'}
                                            ],
                                        })(
                                            <Input placeholder="二维码下的文字描述，如：亲，任何问题都可以添加我的微信，助您本次活动一切顺利"/>
                                        )
                                        :
                                        evt.header.contactQrcodeText
                                }
                            </CkInfoItem>
                        }

                    </Card>
                </Spin>
            </Form>
        )
    }
}


EvtViewWxContactForm.contextTypes = {}

EvtViewWxContactForm.defaultProps = {
    evt: {},
    editableStatePropName: null,
    confDesArr: [],
    editable: false,
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewWxContactForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewWxContactForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewWxContactForm.jsx